"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));
    this.$section = $section;

    if (this.hasMixedPopup) {
      this.handleMixedPopup()
    }
    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      let $parent = $(this).parents('[data-cart-item]')
      let builderIdentifier = $parent.data('builder-identifier')
      let $managementProduct = $section.find(`[data-builder-fees-product="true"][data-builder-identifier="${builderIdentifier}"]`)
      let managementProductLineId = $managementProduct.length ? $managementProduct.data('cart-item') : false;
      var lineID = $parent.data('cart-item');
      Shopify.theme.jsCart.removeFromCart(lineID, managementProductLineId);
      return false;
    }); // Prevent the ajax cart form from being submitted when pressing the "Enter" key

    $('#cart_form').keydown(function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  handleMixedPopup: function handleMixedPopup() {
    let $popup = $('.cart__mixed-popup')
    if ($popup.hasClass('hidden')) { return }
    $('body').addClass('has-overlay')
    let $sBtn = $popup.find('.data-separate-button')
    let $tBtn = $popup.find('.data-together-button')

    $popup.find('button').on('click', function (e) {
      $(this).addClass('is-loading')
      let type = $(this).data('mixed')
      console.log(type)
      $('#delivery-type-field').val(type)
      $popup.addClass('hidden')
      $('body').removeClass('has-overlay')
    })

  },
  removeFromCart: async function removeFromCart(lineID, connectedItemId) {
    let self = this
    var $cartItem = Shopify.theme.jsCart.$section.find("[data-line-item=\"".concat(lineID, "\"]"));
    $cartItem.css('opacity', '0.5');
    if (connectedItemId) {
      let a = await $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&id=' + connectedItemId,
        dataType: 'json'
      })
      console.log(a)
    }
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        $cartItem.addClass('animated zoomOut');
        $cartItem.remove();
        window.location.reload()
        Shopify.theme.jsCart.updateView(cart, lineID);
        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          //             Shopify.theme.jsAjaxCart.updateView();
        }

      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function updateView(cart, lineID) {
    if (cart.item_count > 0) {
      var _$$ajax;

      $.ajax((_$$ajax = {
        dataType: "json",
        async: false,
        cache: false
      }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
        if (lineID !== null) {
          var updatedItems = $(html).find('.cart__item-list .cart__card');
          var currentItems = $('.cart__item-list .cart__card'); // Checks if BOGO applied and there is a change in the number of line items

          if (updatedItems.length != currentItems.length) {
            var updatedCartList = $(html).find('.cart__item-list'); // Re-append cart items

            $('.cart__item-list').replaceWith(updatedCartList);
          }

          $(currentItems).each(function (index, element) {
            $(element).attr('data-line-item', index + 1);
            $(element).find('[data-line-item-key]').attr('data-line-item-key', index + 1);
          });
          var itemTotal = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__total');
          var quantityInput = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-input');
          var itemPrice = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__price');
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__total').replaceWith(itemTotal);
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-input').replaceWith(quantityInput);
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__price').replaceWith(itemPrice);
        }

        var subtotal = $(html).find('.cart__subtotal-container');
        var discounts = $(html).find('.cart__discounts');
        var savings = $(html).find('.cart__total-savings');
        $('.cart__subtotal-container').replaceWith(subtotal);

        if (discounts.length > 0 && $('.cart__discounts').length < 1) {
          $('.cart__subtotal-container').before(discounts);
        } else {
          $('.cart__discounts').replaceWith(discounts);
        }

        if (savings.length > 0 && $('.cart__total-savings').length < 1) {
          $('.cart__subtotal-container').after(savings);
        } else {
          $('.cart__total-savings').replaceWith(savings);
        }

        $('[data-bind="itemCount"]').text(cart.item_count);

        /* Update shipping indicator asynchronously js */
        var amount_for_fs = $('.spend-shipping').attr('data-amt');
        var total_price = cart.total_price;
        if (amount_for_fs > total_price) {
          //udpate
          $('.indicator__msg').find('.indicator__msg-info').removeClass('is-hidden')
          $('.indicator__msg').find('.indicator__msg-success').addClass('is-hidden')
          var amt_required_ffs = amount_for_fs - total_price;
          var percent = total_price / amount_for_fs * 100;
          $('.free-shipping-indicator > div').css('width', percent + '%');
          var indicator_msg = $('.indicator__msg').attr('data-msg');
          indicator_msg = indicator_msg.replace('[[rem_amt]]', Shopify.formatMoney(amt_required_ffs));
          $('.indicator__msg .indicator__msg-info').text(indicator_msg);
          $('.spend-shipping-wrap').show();
        } else {
          //remove shipping indicator
          $('.indicator__msg').find('.indicator__msg-info').addClass('is-hidden')
          $('.indicator__msg').find('.indicator__msg-success').removeClass('is-hidden')
        }

      }), _$$ajax));
    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

    if (Shopify.theme_settings.show_multiple_currencies) {
      convertCurrencies();
    }
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
};